import { useEffect } from 'react';

/**
 * useUrlActionTriggers
 *
 * Escucha los query-params `?openTaskForm=true` y `?openDossier=true`
 * (usados por atajos externos como notificaciones push o accesos rápidos
 * del sistema iOS) y dispara los abridores de modal correspondientes.
 *
 * Extraído de `App.js` (feb-2026) — antes vivía dentro del `useEffect`
 * gigante de sincronización de URL en `AuthenticatedApp`.
 *
 * @param {Object} params
 * @param {boolean} params.isAuthenticated
 * @param {Object}  params.location  — `location` de react-router-dom
 * @param {Function} params.navigate — `navigate` de react-router-dom
 * @param {Function} params.setIsTaskFormOpen
 * @param {Function} params.setIsDossierOpen
 */
export function useUrlActionTriggers({
  isAuthenticated,
  location,
  navigate,
  setIsTaskFormOpen,
  setIsDossierOpen,
}) {
  useEffect(() => {
    if (!isAuthenticated) return;
    const params = new URLSearchParams(location.search);

    if (params.get('openTaskForm') === 'true') {
      setIsTaskFormOpen(true);
      navigate('/', { replace: true });
      return;
    }

    if (params.get('openDossier') === 'true') {
      setIsDossierOpen(true);
      navigate('/', { replace: true });
    }
  }, [location.search, isAuthenticated, navigate, setIsTaskFormOpen, setIsDossierOpen]);
}
